import { normalizeReferralCode, REFERRAL_COOKIE_MAX_AGE_SECONDS } from './shared.js';

export const REFERRAL_STORAGE_KEY = 'bg_ref';

// Mirror attribution for the browser. The server Cookie remains authoritative.
export function captureReferralStorage(storage, { serverCode, queryCode, now = Date.now() } = {}) {
  try {
    const saved = JSON.parse(storage.getItem(REFERRAL_STORAGE_KEY) || 'null');
    const current = normalizeReferralCode(saved?.code) && Number(saved?.expiresAt) > now ? saved : null;
    const authoritative = normalizeReferralCode(serverCode);
    const code = authoritative || current?.code || normalizeReferralCode(queryCode);
    if (!code) {
      storage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }
    const record = current?.code === code ? current : {
      code, expiresAt: now + REFERRAL_COOKIE_MAX_AGE_SECONDS * 1000,
    };
    storage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(record));
    return record;
  } catch {
    // Storage can be unavailable in privacy mode; Cookie attribution still works.
    return null;
  }
}
